/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Layout, Row, Col } from 'antd';
import Modal from '../Modal/Modal';
import TermsConditions from './components/TermsConditions';
import PrivacySecurity from './components/PrivacySecurity';
import { showSocialLinksSelector } from '../../scenes/Organisation/OrganisationSelectors';
import { isPartner } from '../../themes/partnerTheme';
import poweredByLMI from '../Logo/poweredByLMI_white.png';
import './Footer.scss';

const { Footer } = Layout;

function AppFooter({ showSocialLinks }) {
  const isAviva = isPartner('aviva');

  return (
    <Footer className="footer">
      <Row type="flex" justify="space-between" align="middle" className="footer-top">
        <Col xs={24} sm={16}>
          <div className="footer-links">
            <Modal
              title="Terms &amp; Conditions"
              width="auto"
              wrapClassName="terms-conditions-modal"
              toggle={(show) => (
                <button type="button" className="footer-link-btn" onClick={show}>
                  Terms &amp; Conditions
                </button>
              )}
            >
              {() => <TermsConditions />}
            </Modal>
            <span className="footer-link-sep" />
            <Modal
              title="Privacy &amp; Security Statement"
              width="auto"
              wrapClassName="terms-conditions-modal"
              toggle={(show) => (
                <button type="button" className="footer-link-btn" onClick={show}>
                  Privacy Policy
                </button>
              )}
            >
              {() => <PrivacySecurity />}
            </Modal>
            <span className="footer-link-sep" />
            <Link to="/contact-us" className="footer-link-btn">
              Contact Us
            </Link>
            {isAviva ? (
              <>
                <span className="footer-link-sep" />
                <a
                  href="https://www.aviva.co.uk/help-and-support/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link-btn"
                >
                  Aviva Help &amp; Support
                </a>
              </>
            ) : null}
          </div>
        </Col>
        {showSocialLinks ? (
          <Col xs={24} sm={8}>
            <ul className="footer-social-links">
              <li>
                <a
                  href="https://www.linkedin.com/company/lmi-group/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-icon"
                  aria-label="LinkedIn"
                >
                  <i className="fa fa-linkedin" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/LMIGroupPtyLtd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-icon"
                  aria-label="Facebook"
                >
                  <i className="fa fa-facebook" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/user/LMIGROUP"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-icon"
                  aria-label="YouTube"
                >
                  <i className="fa fa-youtube" />
                </a>
              </li>
            </ul>
          </Col>
        ) : (
          <Col xs={24} sm={8} className="footer-powered-by">
            <a href="https://www.lmigroup.io" target="_blank" rel="noopener noreferrer">
              <img src={poweredByLMI} alt="Powered by LMI Group" className="footer-powered-by-logo" />
            </a>
          </Col>
        )}
      </Row>
      <div className="footer-copyright">
        &copy; 2005 &ndash; {new Date().getFullYear()} <strong>LMI Group</strong>. All Rights Reserved.
      </div>
    </Footer>
  );
}

const mapStateToProps = (state) => ({
  showSocialLinks: showSocialLinksSelector(state),
});

export default connect(mapStateToProps)(AppFooter);
